import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEditAssignmentMutation } from "../redux/features/assignments/assignmentAPI";
import { useGetVideosQuery } from "../redux/features/videos/videosAPI";
import {
  useEditAssignmentMarkMutation,
  useGetAssignmentMarksQuery,
} from "../redux/features/assignments/assignmentMarkAPI";
import Error from "./Error";
import usePageTitle from "../utils/usePageTitle";

export default function EditVideoForm({ assignment }) {
  usePageTitle("Edit Assignment");
  const {
    title: updateTitle,
    video_id: updateVideoId,
    video_title: updateVideoTitle,
    totalMark: updateTotalMark,
    id,
  } = assignment;

  const {
    data: videos,
    isLoading: isVideoLoading,
    isError: isVideoError,
  } = useGetVideosQuery();

  const navigate = useNavigate();
  const [editAssignment, { isLoading, error }] = useEditAssignmentMutation();

  const { data: assignmentMarks } = useGetAssignmentMarksQuery();
  const [editAssignmentMark] = useEditAssignmentMarkMutation();
  const concernedAssignmentMarks = assignmentMarks?.filter(
    (assignmentMark) => assignmentMark.title === updateTitle
  );

  let videoContent;
  if (!isVideoLoading && !isVideoError) {
    videoContent = videos.find(
      (video) => video.id === updateVideoId && video.title === updateVideoTitle
    );
  } else videoContent = {};

  const [title, setTitle] = useState(updateTitle);
  const [video, setVideo] = useState(videoContent);
  const [totalMark, setTotalMark] = useState(updateTotalMark);

  const handleSubmit = (e) => {
    e.preventDefault();
    editAssignment({
      id,
      data: {
        title,
        totalMark: parseInt(totalMark),
        video_id: video.id,
        video_title: video.title,
      },
    });

    concernedAssignmentMarks.forEach((assignmentMark) =>
      editAssignmentMark({
        id: assignmentMark.id,
        data: {
          ...assignmentMark,
          title,
          totalMark: parseInt(totalMark),
        },
      })
    );

    navigate("/admin/assignments");
  };

  return (
    <form className="mt-8 space-y-6" onSubmit={(e) => handleSubmit(e)}>
      <div className="rounded-md shadow-sm -space-y-px">
        <div>
          <label
            htmlFor="video"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Associated Video
          </label>
          <select
            name="associatedVideo"
            required
            style={{
              color: "white",
              width: "100%",
              backgroundColor: "rgb(30 41 59 / var(--tw-bg-opacity))",
              height: "40px",
              fontSize: "0.875rem",
            }}
            className="px-3 rounded-md mt-1"
            onChange={(e) =>
              setVideo(videos.find((video) => video.title === e.target.value))
            }
          >
            {!isVideoLoading &&
              !isVideoError &&
              videos.map((video) => (
                <option
                  key={video.id}
                  selected={
                    video.title === updateVideoTitle ? "selected" : null
                  }
                >
                  {video.title}
                </option>
              ))}
          </select>
        </div>

        <br />

        <div>
          <label
            htmlFor="title"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray"
          >
            Title
          </label>

          <input
            id="title"
            name="title"
            type="name"
            autoComplete="name"
            required
            className="login-input rounded-md mt-1"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <br />
        <div>
          <label
            htmlFor="Marks"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          >
            Total Marks
          </label>
          <input
            id="marks"
            name="marks"
            type="number"
            autoComplete="marks"
            required
            className="login-input rounded-md mt-1"
            value={totalMark}
            onChange={(e) => setTotalMark(e.target.value)}
          />
        </div>
      </div>

      <div className="flex justify-end gap-x-2">
        <button
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
        >
          Update
        </button>

        <Link
          to="/admin/assignments"
          type="submit"
          disabled={isLoading}
          className="py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
        >
          Cancel
        </Link>
      </div>

      {error && <Error message={error} />}
    </form>
  );
}
